import React from "react"
import { Link } from 'react-router-dom'
import "./headerNav.css"
import logo from "../Component/images/logo.png"
import homeButton from "../Component/images/home.png"
import notifButton from "../Component/images/notif.png"
import settingsButton from "../Component/images/settings.png"
import AvatarDropdown from "./avatarDropdown"
import magnifyingGlass from "../assets/glass.png"

export default class HeaderNav extends React.Component {

    _handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault()
            this.props.searchWord(event.target.value)
        }
    }

    render() {
        return (
            <div className="headerBar">
                
                <Link to="/" style={{ textDecoration: 'none' }}>
                <div className="headerLeft">
                    <img className="logo" src={logo} alt="logo" height={41} width={53}></img>
                    <div className="webname">Crafting Cannon</div>
                </div>
                </Link>

                <div className="searchBar">
                    <img className="magnifyingGlass" src={magnifyingGlass} alt="magnifyingGlass"></img>
                    <input
                        className="innerSearch"
                        type="text"
                        placeholder="Search"
                        onKeyDown={this._handleKeyDown}>
                    </input>
                </div>

                <div className="headerRight">
                    <Link to="/">
                        <img className="homebutton" src={homeButton} alt="home button"></img>
                    </Link>
                    <Link to="/settings">
                        <img className="settingsbutton" src={settingsButton} alt="settings button"></img>
                    </Link>
                    <AvatarDropdown />
                </div>

            </div>
        )
    }
}